module.exports = __webpack_public_path__ + "img/code.bc68d2db.svg";